import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getClientTypesForAssignToUserLoadingState = (
  state: RootState,
): RootState['clientTypes']['clientTypesForAssignToUser']['loading'] =>
  state.clientTypes.clientTypesForAssignToUser.loading

export const clientTypesForAssignToUserLoading = createSelector(
  getClientTypesForAssignToUserLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getClientTypesForAssignToUserData = (
  state: RootState,
): RootState['clientTypes']['clientTypesForAssignToUser']['data'] => state.clientTypes.clientTypesForAssignToUser.data

export const getClientTypesForAssignToUserEnum = createSelector(getClientTypesForAssignToUserData, (clientTypes) =>
  clientTypes.items.map((clientType) => ({ value: clientType.id, label: clientType.name })),
)
export const getClientTypesForAssignToUserError = (
  state: RootState,
): RootState['clientTypes']['clientTypesForAssignToUser']['error'] => state.clientTypes.clientTypesForAssignToUser.error

export const getClientTypesLoadingState = (state: RootState): RootState['clientTypes']['loading'] =>
  state.clientTypes.loading

export const clientTypesLoading = createSelector(
  getClientTypesLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getClientTypesData = (state: RootState): RootState['clientTypes']['data'] => state.clientTypes.data

export const getClientTypeDetailsLoadingState = (
  state: RootState,
): RootState['clientTypes']['clientTypeDetails']['loading'] => state.clientTypes.clientTypeDetails.loading

export const clientTypeDetailsLoading = createSelector(
  getClientTypeDetailsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getClientTypeDetailsData = (state: RootState): RootState['clientTypes']['clientTypeDetails']['data'] =>
  state.clientTypes.clientTypeDetails.data

export const createClientTypeModal = (state: RootState): RootState['clientTypes']['createClientTypeModal'] =>
  state.clientTypes.createClientTypeModal
export const updateClientTypeModal = (state: RootState): RootState['clientTypes']['updateClientTypeModal'] =>
  state.clientTypes.updateClientTypeModal
export const viewClientTypeModal = (state: RootState): RootState['clientTypes']['viewClientTypeModal'] =>
  state.clientTypes.viewClientTypeModal

export const getListOfClientTypesLoadingState = (
  state: RootState,
): RootState['clientTypes']['listOfClientTypes']['loading'] => state.clientTypes.listOfClientTypes.loading

export const listOfClientTypesLoading = createSelector(
  getListOfClientTypesLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getListOfClientTypesData = (state: RootState): RootState['clientTypes']['listOfClientTypes']['data'] =>
  state.clientTypes.listOfClientTypes.data
